export const EPF_FILING_STATUS_TITLE = 'EPF Filing Status';
export const ESTABLISHMENTS_BUTTON_LABEL = 'Details of Establishments';
export const EPF_DEFAULT_WITHOUT_ESTABLISHMENT = 'Default — establishment not available';
export const NO_EPF_PAYMENTS_TEXT = 'No EPF payments found';
export const LIVE_ESTABLISHMENT_STATUS = 'LIVE ESTABLISHMENT';
export const ESTABLISHMENTS_DRAWER_WIDTH = '41.25rem';

export const EPF_PAYMENT_STATUS_LABELS = {
    ON_TIME: 'On Time',
    DEFAULT: 'Default',
} as const;

export const ESTABLISHMENT_FIELD_LABELS = {
    NAME: 'Name',
    DATE_OF_SETUP: 'Date of Setup :',
    PRINCIPAL_BUSINESS_ACTIVITIES: 'Principal Business Activities',
    WORKING_STATUS: 'Working Status :',
    EXEMPTION_STATUS: 'Exemption Status :',
    EXEMPTION_PF: 'PF :',
    EXEMPTION_PENSION: 'Pension :',
    EXEMPTION_EDLI: 'EDLI :',
    NO_OF_EMPLOYEES: 'No. of Employees',
    LATEST_WAGE_MONTH: 'Latest Wage Month',
    LATEST_DATE_OF_CREDIT: 'Latest Date of Credit',
    LAST_CREDIT: 'Last Credit',
} as const;

/** Grid statuses (`yValue`) that represent a filed or defaulted month — the only cells with a hover. */
export const EPF_HOVERABLE_STATUSES = new Set([1, 2, 3]);

export const ESTABLISHMENT_ID_PREFIX = 'Establishment ID:';
